// Copyright (c) Ping. All rights reserved.
//
// Web orchestrator for the meeting composer (the composer's "Event" attach
// entry → `openMeetingComposer` shell overlay). Renders the `MeetingModal`
// while the `meetingComposer` overlay is active and forwards the draft to the
// host's `com.ping.meeting` send path. `MeetingModal` is built on the shared
// `@ping/ui` `Modal`, which already portals to the top of the document and
// draws the scrim, so the host just drives its `visible` prop — no extra
// react-native `<Modal>` wrapper (that would double the backdrop).

import type React from 'react';

import { type MeetingDraft, MeetingModal, type MeetingModalInitial } from '@features/meetings';

import type { ChatHostProps } from './types';

export interface MeetingComposerHostProps extends ChatHostProps {
  readonly onSubmitDraft: (draft: MeetingDraft) => Promise<void> | void;
  /** When set, the composer opens in edit mode pre-filled with this meeting. */
  readonly editInitial?: MeetingModalInitial | undefined;
}

export const MeetingComposerHost: React.FC<MeetingComposerHostProps> = ({
  vm,
  onSubmitDraft,
  editInitial,
}) => {
  const open = vm.state.activeOverlays.includes('meetingComposer');
  const close = (): void => vm.handlers.closeOverlay('meetingComposer');
  return (
    <MeetingModal
      visible={open}
      mode={editInitial !== undefined ? 'edit' : 'create'}
      {...(editInitial !== undefined ? { initial: editInitial } : {})}
      onClose={close}
      onSubmit={onSubmitDraft}
    />
  );
};
